import { PaycloudBranch } from "../types";

export function isSameAddress(branch: PaycloudBranch) {
  return (branch.address === branch.activityAddress &&
    branch.floor === branch.activityFloor &&
    branch.department === branch.activityDepartment &&
    branch.postalCode === branch.activityPostalCode
  );
}

